export default function limitStringLength(text : string, maxLength : number) : string {
  if(text.length > maxLength)
    return `${text.substring(0, maxLength - 3)}...`;

  return text;
}

export function isUndefined(value : object) : boolean {
  if (value === null) return true;
  if (value === undefined) return true;
  return Object.keys(value).length === 0;
}